<template>
  <SheetContainer
    title="重音"
    desc="长按选中10个字以内的文本，设置重读、拖音、重读+拖音"
  >
    <ul class="sheet-list">
      <li
        v-for="(item, index) in options"
        :key="item.id"
        class="sheet-item"
        :class="{ checked: selectedValue === item.value }"
        @click="onSelect(index)"
      >
        <span>{{ item.name }}</span>
      </li>
      <li
        class="sheet-item remove"
        :class="{ removable }"
        @click="onRemoveClick"
      >
        <span>移除</span>
      </li>
    </ul>
  </SheetContainer>
</template>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import { toast } from "@/utils/util";
import $ from "jquery";
export default {
  props: {
    value: {
      // 选中值信息
      type: String,
      default: "",
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
  },
  components: {
    SheetContainer,
  },
  data() {
    return {
      options: [
        { id: 1, name: "重读", checked: false, value: "1" },
        { id: 2, name: "拖音", checked: false, value: "2" },
        { id: 3, name: "重读+拖音", checked: false, value: "3" },
      ], // 预置的重读选项
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
    };
  },

  computed: {
    removable() {
      return this.selectedValue;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selectedValue = this.value;
      },
    },
  },
  methods: {
    // 校验选中是否合法

    isValid() {
      if (this.selection.el) {
        if ($(this.selection.el).attr("data-type") !== "stress") {
          toast("请选择需要设置的字符");
          return false;
        }
        return true;
      }
      if (!this.selection.rangeText || !this.selection.rangeText.trim()) {
        toast("请选择需要设置的字符");
        return false;
      }
      if (this.selection.rangeText.length > 10) {
        toast("请选中10个字以内的文本");
        return false;
      }
      if (this.selection.isRangeMixed) {
        toast("重音暂不支持与当前功能组合使用");
        return false;
      }
      const $editor = this.$parent;
      if ($editor.hasEffectRange(this.selection.range, "aliasChange")) {
        toast("别名暂不支持与当前功能组合使用");
        return false;
      }

      // 多发音人特效支持检查
      const speakerNotSupport = $editor.isRangeSpeakerNotSupportEffect(
        this.selection.range,
        "stress"
      );
      if (speakerNotSupport) {
        toast(`${speakerNotSupport.name.split("|")[0]}暂不支持重音`);
        return false;
      }
      return true;
    },
    //插入/修改重读
    onSelect(index) {
      if (!this.isValid()) return;
      const selected = this.options[index];
      this.updateValue(selected.value);
    },
    // 删除重读
    onRemoveClick() {
      if (!this.isValid()) return;
      this.updateValue("");
    },
    // 更新重读值
    updateValue(newValue) {
      if (newValue !== this.selectedValue) {
        this.selectedValue = newValue;
        this.$emit("update:value", newValue);
        this.$emit("change", newValue);

        const option = this.options.find((option) => option.value === newValue);
        if (option) {
          window.collectEvent("editor_zhongying", {
            type: option.name,
          });
        }
      }
    },
  },
};
</script>